// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"AnalysisPanel_thoughtProcess__XlN0B"};